<template>
  <div>

    <div class="flex btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

    <div class="columns is-multiline">

      <!-- 상세 정보 -->
      <div class="column is-full" v-if="callReg.product || callReg.partner">
        <div class="box">
          <admin-box-item title="상세 정보">
            <div class="columns is-multiline">
              <div class="column is-6" v-if="callReg.product">
                <admin-form-item label="상품 이름">
                  {{ callReg.product.name }}
                </admin-form-item>
                <admin-form-item label="상품 이미지">
                  <div :style="thumbImgField(callReg.product.imgs[0])"></div>
                </admin-form-item>
              </div>
              <div class="column is-6" v-if="callReg.partner">
                <admin-form-item label="파트너 이름">
                  {{ callReg.partner.name }}
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-half">
        <div class="box">
          <admin-box-item title="전화문의 상세등록">
            <div class="columns is-multiline">
              <div class="column is-full" style="position: relative">
                <admin-form-item label="연락처*">
                   <div class="lp-search-result" v-if="searchUsers.length > 0">
                    <div class="lp-result-item" :key="user.id" @click="selUser(user)"
                          v-for="user in searchUsers">{{ user.phone + ', ' + user.name }}</div>
                  </div>
                  <div class="phone-user" v-if="!callReg.is_guest">
                    <div>{{ callReg.phone }}</div>
                    <i class="material-icons" @click="clickUserDel">close</i>
                  </div>
                   <input v-else
                          class="input"
                          :value="callReg.phone"
                          @input="e => callReg.phone = e.target.value"
                          placeholder="전화번호를 입력해서 회원인지 확인하세요"
                          type="text" maxlength="13">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="이름*">
                  <input class="input"
                          type="text"
                          :value="callReg.name"
                          @input="e => callReg.name = e.target.value"
                         placeholder="비회원인 경우 이름을 입력하세요"
                         :disabled="isUser">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="상담내용">
                  <textarea class="textarea"
                            placeholder="상담 내용을 입력해주세요."
                            v-model="callReg.counsel_content"></textarea>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-half" v-if="isUser">
        <div class="box">
          <admin-box-item title="회원 정보"
                          :useTab="false">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item>
                  <div style="display: flex; flex-wrap: wrap;">
                    <div class="service-performance-info">
                      <span class="label service-performance-info-label">
                        회원 id
                      </span>
                      <div class="flex">
                        <span class="label">{{ userInfo.username }}</span>
                      </div>
                    </div>
                    <div class="service-performance-info">
                      <span class="label service-performance-info-label">
                        회원 이름
                      </span>
                      <div class="flex">
                        <span class="label">{{ userInfo.name }}</span>
                      </div>
                    </div>
                    <div class="service-performance-info">
                      <span class="label service-performance-info-label">
                        회원 연락처
                      </span>
                      <div class="flex">
                        <span class="label">{{ userInfo.phone }}</span>
                      </div>
                    </div>
                  </div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
          <admin-box-item title="처리 내용 메모" v-if="isAdmin"
                          :useTab="false">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="관리자용 로그 및 메모">
                  <admin-log-memo :memoLogsValue.sync="userInfo.memo_logs"
                                  :newMemoValue.sync="newMemo"
                                  placeholder="처리 내용 관련 간단메모를 입력하는 곳 입니다."
                                  @onClickHistoryBtn="res => clickHistoryBtn(res)">
                  </admin-log-memo>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

    </div>

    <div class="flex btn-group-justify-end">
      <div class="button is-primary" @click="saveData">저장하기</div>
    </div>

  </div>
</template>

<script>
  import moment from 'moment';
  import BreadCrumb from '../../module/common/BreadCrumb'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import InputImg from '../../module/common/InputImg'
  import LpAddress from '../../module/common/LpAddress'
  import LpAdmDropInput from '../../module/common/LpAdmDropInput'
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpAdmBtn from '../../module/common/LpAdmBtn'
  import LpCheck from "../../module/common/LpCheck";
  import LpCheckBool from "../../module/common/LpCheckBool";
  import AdminLogMemo from '../../module/common/AdminLogMemo'
  import CreateMixin from "@/mixins/CreateMixin"

  export default {
    name: 'CallReg',
    layout: 'Main',
    components: {
      LpCheckBool,
      LpCheck,
      LpInputText,
      LpRadio, InputImg, LpAddress,
      LpAdmDropInput, LpSortDropDown,
      LpAdmBtn,
      AdminLogMemo
    },
    mixins: [
      CreateMixin
    ],
    watch:{
      'callReg.phone'(n){
        this.callReg.phone = autoHyphenPhone(this.callReg.phone);

        if(n && this.callReg.is_guest && n.length < 11){
          this.$axios.get(this.getUrl('member/user/simple?phone='+n)).then(res=>{
            if(res.status===200){
              this.searchUsers = res.data;
            }
          })
        }
      }
    },
    data () {
      return {
        // user_id 파라미터 있을 경우 true
        isUser: false,
        searchUsers:[],
        nowTime: '',
        // 전화문의 상세등록
        callReg: {
          is_guest:true,
          id:0,
          phone: '',
          name: '',
          user_id:'',
          counsel_content:'',
          order_content: '',
          is_order: true
        },
        // 회원 정보
        userInfo: {
          username: '',
          name: '',
          phone: '',
          memo_logs:[]
        },
        // 처리 내용 메모
        history: [],
        partners: [],
        newMemo: '',
      }
    },
    created() {
      this.getData();
    },
    methods: {
      clickUserDel() {
        this.callReg = {
          is_guest:true,
          id:0,
          phone: '',
          name: '',
          user_id:'',
          counsel_content:'',
          order_content: '',
          is_order: true
        };
        this.userInfo = {
          username: '',
          name: '',
          phone: '',
          memo_logs:[]
        };
      },
      // 검색한 회원 선택
      selUser(user) {
        this.callReg.user_id = user.id;
        this.callReg.phone = user.phone;
        this.callReg.name = user.name;
        this.searchUsers = [];

        this.$axios.get(this.getUrl('member/user/'+this.callReg.user_id))
          .then(res => {
            if (res.status===200) {
              this.userInfo.name = res.data.user.name;
              this.userInfo.username = res.data.user.username;
              this.userInfo.phone = res.data.user.phone;
              this.userInfo.memo_logs = res.data.memo_logs;
              this.callReg.is_guest = false;
            }
          });
      },
      selDate(date) {
        this.callReg.date = date;
      },
      getUserHistory(user_id){
        this.isUser = true;
        this.$axios.get(this.getUrl('member/user/' + user_id))
          .then(res => {
            if (res.status===200) {
              if(!this.callReg.name || !this.callReg.phone) {
                this.callReg.name = res.data.user.name;
                this.callReg.phone = res.data.user.phone;
              }
              this.userInfo.name = res.data.user.name;
              this.userInfo.username = res.data.user.username;
              this.userInfo.phone = res.data.user.phone;
              this.userInfo.memo_logs = res.data.memo_logs;
            }
          });
      },
      clickHistoryBtn(memo) {
        if (memo.trim()==='') return;
        if(this.$route.query.user_id){
          this.$axios.post(this.getUrl('member/user/'+this.$route.query.user_id+'/memo'),{
            content: memo
          }).then(res=>{
            if(res.status===200){
              let now = moment().format('YYYY-MM-DD HH:mm');
              let authorName = '';
              if (this.$store.getters.mode === 'admin') {
                authorName = this.$store.state.auth.admin.username;
              }
              else {
                authorName = this.$store.state.auth.partner.username;
              }
              this.userInfo.memo_logs.splice(0,0,{
                created_time: now,
                author: authorName,
                content: memo
              });
              this.newMemo='';
              this.toast('로그가 저장되었습니다.');
            }
          })
        }
        else if(this.callReg.id){
          this.$axios.post(this.getUrl('member/user/'+this.callReg.user_id+'/memo'),{
            content: memo
          }).then(res=>{
            if(res.status===200){
              let now = moment().format('YYYY-MM-DD HH:mm');
              let authorName = '';
              if (this.$store.getters.mode === 'admin') {
                authorName = this.$store.state.auth.admin.username;
              }
              else {
                authorName = this.$store.state.auth.partner.username;
              }
              this.userInfo.memo_logs.splice(0,0,{
                created_time: now,
                author: authorName,
                content: memo
              });
              this.newMemo='';
              this.toast('로그가 저장되었습니다.');
            }
          })
        }
      },
      saveData() {
        let err = '';
        if(this.callReg.phone==='') err='전화번호를';
        else if(this.callReg.name==='') err='이름을';
        else if(this.callReg.content==='') err='문의내용을';

        if(err){
          this.toast(err+'입력/선택 해주세요.')
          return;
        }

        // 수정하기
        if(this.$route.query.id){
          this.$axios.patch(this.getUrl('inquiry/call/'+this.$route.query.id), this.callReg).then(res=>{
            if(res.status===200){
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath('space/call/all'));
            }
          })
        }
        // 등록하기
        else{
          // 최초 등록할때 product_call_id가 있을경우 만 예외처리 // 회원아이디, product_call의 아이디 같이 넘김
          let data = this.callReg;
          if(this.$route.query.product_call_id) {
            data.user_id = this.$route.query.user_id;
            data.space_product_call_id = this.$route.query.product_call_id;
          }
          this.$axios.post(this.getUrl('inquiry/call'), data).then(res=>{
            if(res.status===200){
              this.$router.replace(this.getPath('space/call/all'));
            }
          })
        }
      },
      getData(){
        this.nowTime = moment().format('YY-MM-DD');
        this.callReg.date = moment().format('YYYY-MM-DD HH:mm');

        if(this.$route.query.id) {
          if(this.isAdmin){
            this.$axios.get('admin/inquiry/call/'+this.$route.query.id)
              .then(res => {
                if(res.status===200) {
                  this.callReg = res.data;
                  if (res.data.user_id) {
                    this.getUserHistory(res.data.user_id);
                  }
                }
              });
          }
          else {
            this.$axios.get('partner/'+ this.$store.getters.partner.space_partner +'/inquiry/call/'+this.$route.query.id, {
              params: {
                user_id: this.$route.query.user_id
              }
            })
              .then(res => {
                if(res.status===200) {
                  this.callReg = res.data;
                  if (res.data.user_id) {
                    this.getUserHistory(res.data.user_id);
                  }
                }
              });
          }

          // 유저 정보가 있는 경우 가져오기*/
        }
        if(this.$store.getters.mode==='admin') {
          this.$axios.get('admin/space/partner/simple').then(res => {
            this.partners = res.data;
          })
        }

        if(this.$route.query.user_id) {
          this.getUserHistory(this.$route.query.user_id);
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_variable'
  //@import '~assets/css/lp_main'

  .call-reg-group-all
    display flex
  .call-reg-group-left
    width 60%
    min-width 600px
  .call-reg-group-right
    min-width 400px
    width 40%
    margin-left 20px
  .call-reg-content-basic
    display flex
  .call-reg-basic-group-1
    width 50%
  .call-reg-basic-group-2
    width 50%
    margin-top 137px
  .call-reg-content-service
    font-size .9rem
    padding-left 20px
  .call-reg-service-group
    margin 8px 0
  .call-reg-history-memo
    height 240px
    margin 0 10px
    font-size .9rem
    display flex
    flex-wrap wrap
    border 1px solid #ddd
    border-radius 3px
    padding 12px
    overflow-y auto
  .history-memo-item
    width 100%
    margin-bottom 12px
  .call-reg-history-btn
    background-color $primary
    color #fff
    display inline-block
    padding 4px 12px
    margin-left 8px
    border-radius 3px
    cursor pointer
    font-size .9rem

  // 탭 메뉴
  .tab-title-group
    display flex
    font-size .9rem
    color #555
    display flex
    width 100%
  .tab-title
    // width 120px
    // padding 10px
    text-align center
    border-radius 3px
    border-bottom 3px solid #f1f7f8
    font-size .85rem
    cursor pointer
    white-space pre
    padding 10px 6px
    width 20%

  .tab-title-selected
    color $primary
    border 3px solid #f1f7f8
    border-bottom none

  .tab-content-group
    // width 100%
    // min-width 500px
    height 300px
    padding 20px
    border 3px solid #f1f7f8
    border-top none
    border-radius 3px

  .call-req-btn
    background-color #008fd9
    color #ffffff
    font-size .85rem
    border-radius 3px
    cursor pointer
    padding 8px 12px
    display inline-block
    margin-bottom 12px

  .lp-search-result
    position absolute
    left 11px
    z-index 10
    border 1px solid #ddd
    list-style: none;
    margin: 0;
    padding: 0;
    background-color: #fff;
    width: calc(100% - 21px);
    max-height: 192px;
    overflow-y: auto;
    top: 63px;

  .lp-result-item
    padding 4px 12px

  .lp-result-item:hover
    background-color #ddd

  .service-performance-info
    display flex
    justify-content space-between
    width 100%
    padding 4px 8px

  .service-performance-info-label
    display inline-block
    width 112px
    min-width 60px
    margin 0
  .phone-user
    border 1px solid #dddddd
    border-radius 4px
    display flex
    align-items center
    justify-content space-between
    padding 4px 12px
    i
      font-size 20px
      color #777
</style>
